// extracted by mini-css-extract-plugin
export default {"root":"Pagination_root__4Kp-I","paginationLink":"Pagination_paginationLink__HmnaG","active":"Pagination_active__zWetR","ellipsis":"Pagination_ellipsis__VezqF"};